import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { AudienceCountsTable } from './audienceCountsTable';
import { PieChart } from './audienceCountsTable/PieChart';
import { InsightPanel } from './InsightPanel';
import { AudienceMeterChart } from './AudienceMeterChart';
import { InsightPanelPlaceholder } from './InsightPanelPlaceholder';
import { AUD_INSIGHTS_GRID_COL_COUNT } from './constants';
import { AudienceCount, InsightType } from '../domain';
import { AUDIENCE_INSIGHTS_METER_FEATURE_FLAG } from '../featureFlags';

type InsightTableProps = {
  title: string;
  isEnabled: boolean;
  message?: string;
  type?: InsightType;
  hasChart?: boolean;
  values?: AudienceCount[];
  isLoading?: boolean;
  showDivider?: boolean;
};

const colSpan = AUD_INSIGHTS_GRID_COL_COUNT / 2;

export const InsightTable = ({
  title,
  isEnabled,
  values,
  type,
  hasChart = false,
  isLoading = false,
  showDivider = false,
}: InsightTableProps) => {
  const isMeterUIEnabled = useFeatureFlag(AUDIENCE_INSIGHTS_METER_FEATURE_FLAG);

  const isChartEnabled = hasChart && !!values?.length;
  const isMeterChartEnabled = isChartEnabled && isMeterUIEnabled;
  const isPieChartEnabled = isChartEnabled && !isMeterUIEnabled;

  return isEnabled && values ? (
    <InsightPanel colSpan={colSpan} title={title} type={type} showDivider={showDivider}>
      <AudienceMeterChart
        audienceCounts={values}
        isLoading={isLoading}
        isEnabled={isMeterChartEnabled}
      />
      <PieChart
        audienceCounts={values}
        isLoading={isLoading}
        hasChart={hasChart}
        isEnabled={isPieChartEnabled}
      />
      <AudienceCountsTable values={values} isLoading={isLoading} hasChart={hasChart} />
    </InsightPanel>
  ) : (
    <InsightPanelPlaceholder colSpan={colSpan} title={title} type={type} />
  );
};
